export default {
  category: {
    default: "all"
  }
};
